import { render, staticRenderFns } from "./ExceptionBehaviorConfigPage.vue?vue&type=template&id=7a83700b&scoped=true"
import script from "./ExceptionBehaviorConfigPage.vue?vue&type=script&lang=js"
export * from "./ExceptionBehaviorConfigPage.vue?vue&type=script&lang=js"
import style0 from "./ExceptionBehaviorConfigPage.vue?vue&type=style&index=0&id=7a83700b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83700b",
  null
  
)

export default component.exports